"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeFieldStrategy = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Checkbox_1 = tslib_1.__importDefault(require("@mui/material/Checkbox"));
const FormControl_1 = tslib_1.__importDefault(require("@mui/material/FormControl"));
const FormControlLabel_1 = tslib_1.__importDefault(require("@mui/material/FormControlLabel"));
const FormGroup_1 = tslib_1.__importDefault(require("@mui/material/FormGroup"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const styles_1 = require("@mui/material/styles");
function DateTimeFieldStrategy(props) {
    const { title, options, value = [], onChange, ...rest } = (0, styles_1.useThemeProps)({ props, name: "DateTimeFieldStrategy" });
    const handleStrategyChange = (e) => {
        const targetValue = e?.target?.value;
        onChange(e, value?.includes(targetValue) ? value.filter((item) => item !== targetValue) : [...value, targetValue]);
    };
    return (react_1.default.createElement(Box_1.default, { sx: { mx: 1 }, ...rest },
        react_1.default.createElement(Typography_1.default, { sx: { display: "block", mb: 1 }, variant: "subtitle2" }, title),
        react_1.default.createElement(FormControl_1.default, null,
            react_1.default.createElement(FormGroup_1.default, null, options.map((strategy) => {
                return (react_1.default.createElement(FormControlLabel_1.default, { sx: { maxWidth: "150px" }, key: strategy?.value, control: react_1.default.createElement(Checkbox_1.default, { name: strategy?.value, checked: value?.includes(strategy?.value), onChange: handleStrategyChange, value: strategy?.value }), label: react_1.default.createElement(Typography_1.default, null, strategy?.label) }));
            })))));
}
exports.DateTimeFieldStrategy = DateTimeFieldStrategy;
exports.default = DateTimeFieldStrategy;
